module.exports = {
    english: "English",
    slovak: "Slovak",
    deutsch: "Deutsch",
    log_in_using_local_account: "Log in using local account",
    user: "User",
    password: "Password",
    ws_icon_connected: "Connected",
    ws_icon_not_connected: "Connection timeout"
}